module.exports = __webpack_public_path__ + "img/icon_apadrina.9fdc169d.svg";